const typeOfSubstitution = [
  { value: 'DG', label: 'DG' },
  { value: 'GAPD', label: 'GAPD' },
];

  
  
  export const form = [
    { display: true, input: "input", label: "Nom", name: "name", type: "text", page: 0 },
    { display: true, input: "input", label: "Email", name: "email", type: "email", page: 0 },
    { display: true, input: "input", label: "Téléphone", name: "phone", type: "text", page: 0 },
    { display: true, input: "input", label: "Raison social", name: "company", type: "text", page: 0 },
    { display: true, input: "input", label: "Montant du loyer HT HC (€)", name: "rentAmount", type: "number", page: 1 },
    { display: true, input: "select", label: "Que souhaitez vous substituer ? ", name: "substitution", options: typeOfSubstitution, page: 1 },
    { display: true, input: "input", label: "Equivalent mois de loyer", name: "depositAmount", type: "number", page: 1 },
    { display: true, input: "file", label: "KBIS", filename: `kbis_{sessionID}`, name: "identity", type: "file", page: 2 },
    { display: true, input: "file", label: "Les deux derniers bilans (si disponibles)", filename: `balances_{sessionID}`, name: "balance", type: "file", page: 2 },
    { display: true, input: "file", label: "Projet de bail ou bail", filename: `projet_de_bail_{sessionID}`, name: "draftLease", type: "file", page: 2 },
    { display: true, input: "file", label: "Tout autre document (ZIP)", filename: `other_document_{sessionID}`, name: "presentationSheet", type: "file", page: 2 }
];


export const getKeysList = () => {
  let o = {};
  form.forEach((f) => {
    o[f.name] = f.label; 
  })
  return o;
}

const updateObject = function(selector, arr, update) {
  arr = arr.map((item) => {
     let isItem = true;
     for(let key in selector) {
       if(item[key] !== selector[key]) isItem = false;
     }
     if(isItem) {
       item = { ...item, ...update };
     }
     return item;
  });
  return arr;
}

export const dynamicModifications = function(form, document) {
    return { newForm: form, newDocument: document }
}

export const detailsPerPage = [
  { number: 0, title: 'Identité' },
  { number: 1, title: 'Information' },
  { number: 2, title: 'Documents' },
]